import React from 'react'
import styled from 'styled-components'
import SectionTitle from 'src/components/SectionTitle'
import { Dropdown } from 'semantic-ui-react'
import InputWrapper from 'src/components/InputWrapper'
import InputTime from 'src/components/tabs/InputTime'
import WeekAdvancedSetting from 'src/components/tabs/WeekAdvancedSetting'
import MonthAdvancedSetting from 'src/components/tabs/MonthAdvancedSetting'
import YearAdvancedSetting from 'src/components/tabs/YearAdvancedSetting'
import { AppContext } from 'src/context/AppContext'

const intervalOptions = [
  { key: 'day', value: 'day', text: '毎日' },
  { key: 'week', value: 'week', text: '毎週' },
  { key: 'otherWeek', value: 'otherWeek', text: '隔週' },
  { key: 'month', value: 'month', text: '毎月' },
  { key: 'year', value: 'year', text: '毎年' }
]

class Repeat extends React.Component {
  AdvancedSetting = ({ interval }) => {
    switch (interval) {
      case 'week':
        return <WeekAdvancedSetting />
      case 'otherWeek':
        return <WeekAdvancedSetting />
      case 'month':
        return <MonthAdvancedSetting />
      case 'year':
        return <YearAdvancedSetting />
      default:
        return ''
    }
  }

  render () {
    return (
      <AppContext.Consumer>
        {({ state, actions }) => (
          <div>
            <InputWrapper>
              <SectionTitle>間隔</SectionTitle>
              <div>
                <StyledDoropdown
                  name={'interval'}
                  selection
                  options={intervalOptions}
                  value={state.interval}
                  placeholder={'Select an interval'}
                  onChange={actions.onChangeInterval}
                />
              </div>
            </InputWrapper>
            <this.AdvancedSetting interval={state.interval} />
            <InputTime />
          </div>
        )}
      </AppContext.Consumer>
    )
  }
}

export default Repeat

const StyledDoropdown = styled(Dropdown)`
  && {
    @media (max-width: 830px) {
      width: 100%;
    }
  }
`
